export default __webpack_public_path__ + "static/media/FR_2.ae05fa0e.png";